import { Action } from '@ngrx/store';

export enum EUploadBexActions {
  SetLocalBexFile = '[Upload bex file] set bex file on local state',
  RemoveSelectedBexFile = '[Upload bex file] remove bex file from de state',
  UploadBexFile = '[Upload bex file] send to server the bex file selected',
  UploadBexFileSuccess = '[Upload bex file] send to server the bex file selected success',
  GetBexHistory = '[Upload bex file] get the upload bex history.',
  GetBexHistorySuccess = '[Upload bex file] get the upload bex history success.',
  GetBexHistoryError = '[Upload bex file] get the upload bex history error.',
  DownloadTraceFile = '[Upload bex file] download trace file to the bex',
  DownloadTraceFileSuccess = '[Upload bex file] download trace file to the bex success',
  GetCurrentBEXFromServer = '[Upload bex file] get current bex file from server',
  GetCurrentBEXFromServerSuccess = '[Upload bex file] get current bex file from server success',
  GetObjectListMaintenanceReasons = '[Upload bex file] get ObjectListMaintenanceReasons.',
  GetObjectListMaintenanceReasonsSuccess = '[Upload bex file] get ObjectListMaintenanceReasons success.',
  ApplyBexUpload = '[Upload bex file] Apply bex upload.',
  ApplyBexUploadSuccess = '[Upload bex file] Apply bex upload success.',
  GetBexImportStatus = '[Upload bex file] Get bex import status.',
  GetBexImportStatusSuccess = '[Upload bex file] Get bex import status success.',
  CancelBexImport = '[Upload bex file] Cancel bex import.',
  CancelBexImportSuccess = '[Upload bex file] Cancel bex import success.',
  AvoidReload = '[Upload bex file] Avoid reload.',
  AllowReload = '[Upload bex file] Allow reload.',
  CheckEncrypt = '[Upload bex file] Check Encrypt.',
  CheckEncryptSuccess = '[Upload bex file] Check Encrypt Success.',
}

export class SetLocalBexFile implements Action {
  public readonly type = EUploadBexActions.SetLocalBexFile;
  constructor(public payload: File) { }
}

export class RemoveSelectedBexFile implements Action {
  public readonly type = EUploadBexActions.RemoveSelectedBexFile;
}

export class UploadBexFile implements Action {
  public readonly type = EUploadBexActions.UploadBexFile;
}

export class UploadBexFileSuccess implements Action {
  public readonly type = EUploadBexActions.UploadBexFileSuccess;
  constructor(public payload: any) { }
}

export class GetBexHistory implements Action {
  public readonly type = EUploadBexActions.GetBexHistory;
}

export class GetBexHistorySuccess implements Action {
  public readonly type = EUploadBexActions.GetBexHistorySuccess;
  constructor(public payload: Array<any>) { }
}

export class GetBexHistoryError implements Action {
  public readonly type = EUploadBexActions.GetBexHistoryError;
  constructor(public payload: any) { }
}

export class DownloadTraceFile implements Action {
  public readonly type = EUploadBexActions.DownloadTraceFile;
  constructor(public payload: string) { }
}

export class DownloadTraceFileSuccess implements Action {
  public readonly type = EUploadBexActions.DownloadTraceFileSuccess;
  constructor(public payload: any) { }
}

export class GetCurrentBEXFromServer implements Action {
  public readonly type = EUploadBexActions.GetCurrentBEXFromServer;
}

export class GetCurrentBEXFromServerSuccess implements Action {
  public readonly type = EUploadBexActions.GetCurrentBEXFromServerSuccess;
  constructor(public payload: ICurrentBexFromServer) { };
}

export class GetObjectListMaintenanceReasons implements Action {
  public readonly type = EUploadBexActions.GetObjectListMaintenanceReasons;
}

export class GetObjectListMaintenanceReasonsSuccess implements Action {
  public readonly type = EUploadBexActions.GetObjectListMaintenanceReasonsSuccess;
  constructor(public payload: Array<string>) { }
}

export class ApplyBexUpload implements Action {
  public readonly type = EUploadBexActions.ApplyBexUpload;
}

export class ApplyBexUploadSuccess implements Action {
  public readonly type = EUploadBexActions.ApplyBexUploadSuccess;
  constructor(public payload: any) { }
}

export class GetBexImportStatus implements Action {
  public readonly type = EUploadBexActions.GetBexImportStatus;
}

export class GetBexImportStatusSuccess implements Action {
  public readonly type = EUploadBexActions.GetBexImportStatusSuccess;
  constructor(public payload: string) { }
}

export class CancelBexImport implements Action {
  public readonly type = EUploadBexActions.CancelBexImport;
}

export class CancelBexImportSuccess implements Action {
  public readonly type = EUploadBexActions.CancelBexImportSuccess;
  constructor() { }
}

export class AvoidReload implements Action {
  public readonly type = EUploadBexActions.AvoidReload;
}

export class AllowReload implements Action {
  public readonly type = EUploadBexActions.AllowReload;
}

export class CheckEncrypt implements Action {
  public readonly type = EUploadBexActions.CheckEncrypt;
  constructor(public payload: any) { }
}

export class CheckEncryptSuccess implements Action {
  public readonly type = EUploadBexActions.CheckEncryptSuccess;
  constructor(public payload?: any) { }
}

export type UploadBexActions =
  | SetLocalBexFile
  | RemoveSelectedBexFile
  | UploadBexFile
  | UploadBexFileSuccess
  | GetBexHistory
  | GetBexHistorySuccess
  | GetBexHistoryError
  | DownloadTraceFile
  | DownloadTraceFileSuccess
  | GetCurrentBEXFromServer
  | GetCurrentBEXFromServerSuccess
  | GetObjectListMaintenanceReasons
  | GetObjectListMaintenanceReasonsSuccess
  | ApplyBexUpload
  | ApplyBexUploadSuccess
  | GetBexImportStatus
  | GetBexImportStatusSuccess
  | AvoidReload
  | AllowReload
  | CheckEncrypt
  | CheckEncryptSuccess;
